import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function LspdPlusCircle({
  size = MAIN_THEME.iconSize.small,
  color = MAIN_THEME.colors.lspdBlue500,
}: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}>
      <path
        d="M7 7H4c-.516 0-1 .264-1 1 0 .742.531 1 1 1h3v3c0 .453.264 1 1 1 .742 0 1-.547 1-1V9h3c.437 0 1-.263 1-1 0-.741-.531-1-1-1H9V4c0-.422-.264-1-1-1-.742 0-1 .547-1 1v3z"
        fill={color}
      />
    </svg>
  );
}
